import React, { useMemo } from 'react';

import { getGroupTotalAmountString, isExpenseEventType } from 'components/pages/finance/NewInvoice/services/service';

import { stylesContent } from '../../EncounterInvoiceTemplateStyles';

export const Header = ({ item }) => {
  let isOnlyAdjustmentsExpenseGroupCont = useMemo(() => {
    return (
      isExpenseEventType(item.headerBudgetEventType) && item.groupHeaderSuffix === '(cont.)' && item.groupLength === 0
    );
  }, [item]);

  return (
    <>
      <div style={stylesContent.groupHeader} className="row-item" data-testid="event-group-amount-calculation">
        <div style={stylesContent.groupHeader.groupItemName}>
          {isExpenseEventType(item.headerBudgetEventType) ? item.groupNameForFixedAndVariableEvents : item.groupName}
          {item.groupHeaderSuffix ?? ''}
        </div>
        <div style={{ width: '45px' }} />
        {!(item.groupHeaderSuffix && item?.inseparable) && !isOnlyAdjustmentsExpenseGroupCont && (
          <>
            <div style={stylesContent.groupHeader.groupItem}>{item.groupLength}</div>
            <div style={stylesContent.groupHeader.tableHeaderItemAmount}>{getGroupTotalAmountString(item)}</div>
          </>
        )}
        {item.groupOpenBalance !== 0 && <div style={{ fontWeight: 500 }}>{item.groupOpenBalanceString}</div>}
      </div>
    </>
  );
};
